import React from "react";
import styles from "../../style.module.scss";

/**
 * PricingCard component for displaying pricing information in a card layout
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Card content
 * @param {string} props.title - Card title
 * @param {React.ReactNode} props.icons - Optional card icons
 * @param {string} [props.className] - Additional CSS class names
 * @returns {React.ReactElement} PricingCard component
 */
const PricingCard = ({ children, title, icons, className }) => {
  return (
    <div className={`${styles.rateCard} ${className || ""}`}>
      {(title || icons) && (
        <div className={styles.cardHeader}>
          {title && <h6 className={styles.cardTitle}>{title}</h6>}
          {icons && <div className={styles.cardIcons}>{icons}</div>}
        </div>
      )}
      {children}
    </div>
  );
};

export default PricingCard;
